import { render, staticRenderFns } from "./FooterVue.vue?vue&type=template&id=0b4eec08&scoped=true"
import script from "./FooterVue.vue?vue&type=script&lang=js"
export * from "./FooterVue.vue?vue&type=script&lang=js"
import style0 from "./FooterVue.vue?vue&type=style&index=0&id=0b4eec08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4eec08",
  null
  
)

export default component.exports